import { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { createPairingRequestApi, pollPairingRequestApi } from '../apis';
import { runPairing } from '../lib/pairing';
import { useAppStateContext } from '@/shared';
import { screenInfoWithAppVersion } from '@/utils/functions';

const sessionStore = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

// Shows a pairing code and waits for an admin to add this TV in the console.
export const usePageSignIn = () => {
  const { setAppState } = useAppStateContext();
  const [state, setState] = useImmer({
    code: null,
    pairUrl: null,
    isOffline: false,
  });

  useEffect(() => {
    const controller = new AbortController();

    runPairing({
      api: {
        createRequest: async () =>
          createPairingRequestApi({
            screenInfo: JSON.stringify(await screenInfoWithAppVersion()),
          }),
        poll: pollPairingRequestApi,
      },
      storage: sessionStore(),
      signal: controller.signal,
      onCode: (request) =>
        setState((draft) => {
          draft.code = request.code;
          draft.pairUrl = request.pairUrl;
          draft.isOffline = false;
        }),
      onError: () =>
        setState((draft) => {
          draft.isOffline = true;
        }),
      // Home swaps to the player as soon as these credentials land in app state.
      onPaired: (screen) => {
        setAppState((draft) => {
          // tid is the tenant identifier (storage paths + realtime channel names).
          draft.tid = screen.tenant;
          draft.screenInfo = {
            name: screen.name,
            accessToken: screen.accessToken,
            screenId: screen.screenId,
            locationId: screen.locationId,
            groupId: screen.groupId,
            timeZone: screen.timeZone,
            orientation: screen.orientation,
          };
        });
      },
    });

    return () => controller.abort();
  }, [setAppState, setState]);

  return { state };
};
